import { Typography } from '@components/typography';
import { DatasetJob, useGetOrganizationSettingsQuery } from '@generated/graphql';
import { getFormattedDurationString } from '@helper-functions/durationDisplay';
import { Grid, useTheme } from '@mui/material';
import { useCurrentOrganizationId } from '@navigation/WorkspaceContext';
import { JobsManagerJobPreviewDataField } from './JobsManagerJobPreviewDataField';

export const JobsManagerJobPreviewInstances = ({
  averageRuntime,
  instancesStarting,
  instancesRunning,
}: DatasetJob) => {
  const { palette } = useTheme();
  const organizationId = useCurrentOrganizationId();
  const { data: organizationSettingsData } = useGetOrganizationSettingsQuery({
    variables: { organizationId, setting: 'Instances' },
  });
  return (
    <Grid container columns={20}>
      <Grid item xs={5}>
        <Typography variant="caption2" color={palette.text.paper}>
          Instances
        </Typography>
      </Grid>
      <JobsManagerJobPreviewDataField
        label="Limit"
        value={organizationSettingsData?.getOrganizationSettings?.[0]?.limit || 0}
        width={3}
      />
      <JobsManagerJobPreviewDataField
        label="Assigned"
        value={instancesStarting + instancesRunning || 0}
        width={3}
      />
      <JobsManagerJobPreviewDataField label="Starting" value={instancesStarting || 0} width={3} />
      <JobsManagerJobPreviewDataField label="Running" value={instancesRunning || 0} width={3} />
      <JobsManagerJobPreviewDataField
        label="Avg time"
        value={getFormattedDurationString(averageRuntime || 0)}
        width={3}
      />
    </Grid>
  );
};
